import React from "react";
import shortid from "shortid";
import {MenuType} from "../../../../enum/menu/MenuType";
import {MenuSetMenu} from "../../../../types/admin/menuSet";

interface MenuListPreviewProps {
  menuList: MenuSetMenu[];
  nest: number[];
  onChangeViewMenuList: (nest: number[]) => Promise<void>
  activeNest: number[];
}

interface MenuPreviewProps {
  menuList: MenuSetMenu[];
  parentNest: number[];
  onChangeViewMenuList: (nest: number[]) => Promise<void>;
  activeNest: number[];
}
const MenuPreview = (props: MenuPreviewProps) => {
  const { menuList, parentNest, onChangeViewMenuList, activeNest } = props;
  const handleChangeViewMenu = async (index: number) => {
    await onChangeViewMenuList(parentNest.concat([index]));
  };
  const indent = (parentNest.length + 1) * 4;

  const isSubMenuActive = (index: number): boolean => {
    return JSON.stringify(parentNest.concat([index])) === JSON.stringify(activeNest);
  }

  return (
    <>
      {
        menuList.map((menu, index) => {
          if (menu.menuTypeId === MenuType.SUB_MENU) {
            return (
              <div key={shortid.generate()}>
                <button className={`min-w-full text-left text-sm font-semibold text-blue-500 underline focus:outline-none mb-2 p-1 ${isSubMenuActive(index) ? 'bg-gray-200 text-blue-800' : 'text-blue-500' }`}
                        type="button"
                        onClick={() => handleChangeViewMenu(index)}
                ><span className={`ml-${indent}`}>▼ {menu.name}</span>
                </button>
                <MenuPreview
                  menuList={menu.subMenuList}
                  parentNest={parentNest.concat([index])}
                  onChangeViewMenuList={onChangeViewMenuList}
                  activeNest={activeNest}
                />
              </div>
            );
          }

          return (
            <div className="text-sm font-semibold focus:outline-none mb-2 ml-2 p-1" key={shortid.generate()}>
              <span className={`ml-${indent}`}>{menu.name}</span>
            </div>
          );
        })
      }
    </>
  );
};

export const MenuListPreview = (props: MenuListPreviewProps) => {
  const { menuList, nest, onChangeViewMenuList, activeNest } = props;
  const handleChangeViewMenu = async () => {
    await onChangeViewMenuList([]);
  };

  const isRootMenuActive = (): boolean => {
    return activeNest.length === 0;
  }

  return (
    <>
      <div className='bg-white rounded p-4'>
        <div className="overflow-scroll">
          <div className="inline-block min-w-full">
            <button className={`min-w-full text-left text-sm font-semibold underline focus:outline-none mb-2 p-1 ${isRootMenuActive() ? 'bg-gray-200 text-blue-800' : 'text-blue-500' }`}
                    type="button"
                    onClick={handleChangeViewMenu}
            >▼ 最上位メニュー</button>
            <MenuPreview
              menuList={menuList}
              parentNest={nest}
              onChangeViewMenuList={onChangeViewMenuList}
              activeNest={activeNest}
            />
          </div>
        </div>
      </div>
    </>
  );
};